// extracted by mini-css-extract-plugin
module.exports = {"title":"PanelBenefits_title__Dd75a"};